import { SubscriptionIntegrationSchema } from "@redotech/redo-subscriptions-common/subscription-integration";
import * as z from "zod";

export const editSubscription = {
  name: "editSubscription" as const,
  input: z.object({
    subscriptionId: z.number(),
    updates: z.object({
      quantity: z.number().optional(),
      orderIntervalFrequency: z.number().optional(),
      orderIntervalUnit: z.enum(["day", "week", "month"]).optional(),
      nextChargeScheduledAt: z.string().optional(),
      price: z.string().optional(),
    }),
  }),
  output: z.object({ subscription: SubscriptionIntegrationSchema }),
};
